import React from "react";
import { useUser } from "components/hooks/useUser";
import APILink from "components/ui/APILink";

export function FinaidDataNotAvailable() {
  const {
    financialAidSummary: { links = {} },
  } = useUser((user) => user.financialAidSummary || {});

  const finaidWebsiteLinkURL = links?.financialAidWebsite?.url;
  const calStudentCentralURL = links?.calStudentCentral?.url;

  return (
    <div>
      You do not currently have any Financial Aid information ready to view.
      Please check{" "}
      {finaidWebsiteLinkURL ? (
        <>
          <APILink
            link={links.financialAidWebsite}
            text="Financial Aid & Scholarships"
          />
        </>
      ) : (
        <>Financial Aid &amp; Scholarships</>
      )}{" "}
      or contact{" "}
      {calStudentCentralURL ? (
        <>
          <APILink link={links.calStudentCentral} />
        </>
      ) : (
        <>Cal Student Central</>
      )}{" "}
      for more information.
    </div>
  );
}
